/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Review_Titleplaceholder1Inputs */

const id_forms_review_titleplaceholder1 = /** @type {(inputs: Forms_Review_Titleplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masukkan judul untuk ulasan Anda`)
};

const ms_forms_review_titleplaceholder1 = /** @type {(inputs: Forms_Review_Titleplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masukkan tajuk untuk ulasan anda`)
};

const da_forms_review_titleplaceholder1 = /** @type {(inputs: Forms_Review_Titleplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indtast en titel til din anmeldelse`)
};

const de_forms_review_titleplaceholder1 = /** @type {(inputs: Forms_Review_Titleplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie einen Titel für Ihre Bewertung ein`)
};

const en_us2_forms_review_titleplaceholder1 = /** @type {(inputs: Forms_Review_Titleplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a title for your review`)
};

const es_es2_forms_review_titleplaceholder1 = /** @type {(inputs: Forms_Review_Titleplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce un título para tu reseña`)
};

const es_mx2_forms_review_titleplaceholder1 = /** @type {(inputs: Forms_Review_Titleplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa un título para tu reseña`)
};

const fil_forms_review_titleplaceholder1 = /** @type {(inputs: Forms_Review_Titleplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magpasok ng pamagat para sa iyong review`)
};

const fr_forms_review_titleplaceholder1 = /** @type {(inputs: Forms_Review_Titleplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez un titre pour votre avis`)
};

const it_forms_review_titleplaceholder1 = /** @type {(inputs: Forms_Review_Titleplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un titolo per la tua recensione`)
};

const hu_forms_review_titleplaceholder1 = /** @type {(inputs: Forms_Review_Titleplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adj címet az értékelésednek`)
};

const nl_forms_review_titleplaceholder1 = /** @type {(inputs: Forms_Review_Titleplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer een titel in voor je review`)
};

const no_forms_review_titleplaceholder1 = /** @type {(inputs: Forms_Review_Titleplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skriv inn en tittel for omtalen din`)
};

const pl_forms_review_titleplaceholder1 = /** @type {(inputs: Forms_Review_Titleplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wprowadź tytuł recenzji`)
};

const pt_br2_forms_review_titleplaceholder1 = /** @type {(inputs: Forms_Review_Titleplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a title for your review`)
};

const pt_forms_review_titleplaceholder1 = /** @type {(inputs: Forms_Review_Titleplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insira um título para a sua avaliação`)
};

const ro_forms_review_titleplaceholder1 = /** @type {(inputs: Forms_Review_Titleplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introdu un titlu pentru recenzia ta`)
};

const fi_forms_review_titleplaceholder1 = /** @type {(inputs: Forms_Review_Titleplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Syötä arvostelullesi otsikko`)
};

const sv_forms_review_titleplaceholder1 = /** @type {(inputs: Forms_Review_Titleplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ange en titel för din recension`)
};

const vi_forms_review_titleplaceholder1 = /** @type {(inputs: Forms_Review_Titleplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập tiêu đề cho đánh giá của bạn`)
};

const tr_forms_review_titleplaceholder1 = /** @type {(inputs: Forms_Review_Titleplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yorumunuz için bir başlık girin`)
};

const cs_forms_review_titleplaceholder1 = /** @type {(inputs: Forms_Review_Titleplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zadejte název své recenze`)
};

const bg_forms_review_titleplaceholder1 = /** @type {(inputs: Forms_Review_Titleplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Въведете заглавие за вашето ревю`)
};

const ru_forms_review_titleplaceholder1 = /** @type {(inputs: Forms_Review_Titleplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите заголовок для вашего обзора`)
};

const uk_forms_review_titleplaceholder1 = /** @type {(inputs: Forms_Review_Titleplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введіть заголовок для відгуку`)
};

const ar_forms_review_titleplaceholder1 = /** @type {(inputs: Forms_Review_Titleplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أدخل عنوانًا لمراجعتك`)
};

const hi_forms_review_titleplaceholder1 = /** @type {(inputs: Forms_Review_Titleplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शीर्षक दर्ज करें`)
};

const th_forms_review_titleplaceholder1 = /** @type {(inputs: Forms_Review_Titleplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ป้อนชื่อเรื่องสำหรับรีวิวของคุณ`)
};

const ja_forms_review_titleplaceholder1 = /** @type {(inputs: Forms_Review_Titleplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レビューのタイトルを入力`)
};

const zh_cn2_forms_review_titleplaceholder1 = /** @type {(inputs: Forms_Review_Titleplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a title for your review`)
};

const zh_hant1_forms_review_titleplaceholder1 = /** @type {(inputs: Forms_Review_Titleplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a title for your review`)
};

const ko_forms_review_titleplaceholder1 = /** @type {(inputs: Forms_Review_Titleplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a title for your review`)
};

/**
* | output |
* | --- |
* | "Enter a title for your review" |
*
* @param {Forms_Review_Titleplaceholder1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_review_titleplaceholder1 = /** @type {((inputs?: Forms_Review_Titleplaceholder1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Review_Titleplaceholder1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_review_titleplaceholder1(inputs)
	if (locale === "ms") return ms_forms_review_titleplaceholder1(inputs)
	if (locale === "da") return da_forms_review_titleplaceholder1(inputs)
	if (locale === "de") return de_forms_review_titleplaceholder1(inputs)
	if (locale === "en-US") return en_us2_forms_review_titleplaceholder1(inputs)
	if (locale === "es-ES") return es_es2_forms_review_titleplaceholder1(inputs)
	if (locale === "es-MX") return es_mx2_forms_review_titleplaceholder1(inputs)
	if (locale === "fil") return fil_forms_review_titleplaceholder1(inputs)
	if (locale === "fr") return fr_forms_review_titleplaceholder1(inputs)
	if (locale === "it") return it_forms_review_titleplaceholder1(inputs)
	if (locale === "hu") return hu_forms_review_titleplaceholder1(inputs)
	if (locale === "nl") return nl_forms_review_titleplaceholder1(inputs)
	if (locale === "no") return no_forms_review_titleplaceholder1(inputs)
	if (locale === "pl") return pl_forms_review_titleplaceholder1(inputs)
	if (locale === "pt-BR") return pt_br2_forms_review_titleplaceholder1(inputs)
	if (locale === "pt") return pt_forms_review_titleplaceholder1(inputs)
	if (locale === "ro") return ro_forms_review_titleplaceholder1(inputs)
	if (locale === "fi") return fi_forms_review_titleplaceholder1(inputs)
	if (locale === "sv") return sv_forms_review_titleplaceholder1(inputs)
	if (locale === "vi") return vi_forms_review_titleplaceholder1(inputs)
	if (locale === "tr") return tr_forms_review_titleplaceholder1(inputs)
	if (locale === "cs") return cs_forms_review_titleplaceholder1(inputs)
	if (locale === "bg") return bg_forms_review_titleplaceholder1(inputs)
	if (locale === "ru") return ru_forms_review_titleplaceholder1(inputs)
	if (locale === "uk") return uk_forms_review_titleplaceholder1(inputs)
	if (locale === "ar") return ar_forms_review_titleplaceholder1(inputs)
	if (locale === "hi") return hi_forms_review_titleplaceholder1(inputs)
	if (locale === "th") return th_forms_review_titleplaceholder1(inputs)
	if (locale === "ja") return ja_forms_review_titleplaceholder1(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_review_titleplaceholder1(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_review_titleplaceholder1(inputs)
	return ko_forms_review_titleplaceholder1(inputs)
});
export { forms_review_titleplaceholder1 as "forms.review.titlePlaceholder" }